import React, { useState, useEffect } from "react";
import { Modal, Table } from "antd";
import { Api } from "../../../common/Api";

interface VolunteerHistoryDlgProps {
  visible: boolean;
  onClose: () => void;
  userId: string;
}

const VolunteerHistoryDlg: React.FC<VolunteerHistoryDlgProps> = ({ visible, onClose, userId }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    Api.volunteer.history({ userId }).then((res) => {
      setHistory(res.data.volunteerHistory.items);
      setLoading(false);
    });
  }, [userId]);

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
    },
    {
      title: "Participants",
      dataIndex: "participants",
      key: "participants",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
  ];

  return (
    <Modal title="Volunteer History" visible={visible} onCancel={onClose} footer={null} width="60%">
      <Table dataSource={history} columns={columns} loading={loading} />
    </Modal>
  );
};

export default VolunteerHistoryDlg;
